import { api } from "./api";

export const updateClient = async (id: number, data: any) => {
  console.log("Dados para atualização de cliente: ", id, data);
  return api.patch(`/client/update`, { id, data });
};

export const create = async (data: any) => {
  console.log("Dados para cadastro de cliente: ",data);
  return api.post(`/client/create`, data);
};

export const list = async (atendente_id?: string) => {
  return api.get(`/client/list`, { params: { atendente_id } });
};

export const deleteClient = async (id: string) => {
  return api.delete(`/client/${id}`);
};

export const findByPhone = async (phone: string) => {
  return api.get(`/client/findByPhone/${phone}`);
};

const clientApi = {
  updateClient,
  create,
  list,
  deleteClient,
  findByPhone,
};

export default clientApi;
